import React, { useState } from "react";

// Official logo from thekpracademy.org. If it cannot be reached,
// we fall back to the KPR monogram mark so the header never breaks.
export const KPR_LOGO_URL =
  "https://www.thekpracademy.org/assets/KPR_theme5/images/logo.png";

export default function Logo({ variant = "dark", height = 52 }) {
  const [failed, setFailed] = useState(false);
  const onLight = variant === "light"; // rendered on a light background

  if (failed) {
    return (
      <span className="flex items-center gap-3">
        <span
          className="font-display grid place-items-center rounded-xl text-[1.05rem] font-semibold"
          style={{
            height,
            width: height,
            background: onLight ? "var(--teal-800)" : "rgba(255,255,255,.14)",
            color: "var(--gold-200)",
            border: "1px solid rgba(216,169,79,.45)",
          }}
        >
          KPR
        </span>
        <span className="leading-tight">
          <span
            className="font-display block text-[1.06rem]"
            style={{ color: onLight ? "var(--teal-900)" : "#fff" }}
          >
            The KPR Academy
          </span>
          <span
            className="block text-[0.66rem] uppercase tracking-[0.2em]"
            style={{ color: onLight ? "var(--gold)" : "rgba(235,214,168,.9)" }}
          >
            Growing by Giving
          </span>
        </span>
      </span>
    );
  }

  return (
    <span
      className="grid place-items-center rounded-xl px-4 py-2"
      style={{
        background: "#FFFFFF",
        border: "1px solid rgba(11,59,54,.08)",
        boxShadow: onLight ? "none" : "0 10px 26px -18px rgba(0,0,0,.6)",
      }}
    >
      <img
        src={KPR_LOGO_URL}
        alt="The KPR Academy"
        onError={() => setFailed(true)}
        style={{ height, width: "auto", display: "block", objectFit: "contain" }}
      />
    </span>
  );
}
